import React from 'react';
import { Container, Typography, Box, Grid, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { AboutSection, ProfileImage } from '../styles/home.styles';
import { useLoaderData } from 'react-router-dom';

const AboutMe = () => {
    const { meInfo } = useLoaderData();
    const theme = useTheme();

    const description = `A seasoned technology professional with over 12 years of hands-on experience across the software development lifecycle, contributing significantly to software development, functional and automation testing, integration testing, and data analytics.`;

    const expertise = `My expertise extends significantly into the mortgage industry, where I possess profound technical knowledge of Retail and Wholesale Point of Sale Origination platforms. I have a comprehensive understanding of the entire mortgage process, including loan application (URLA), Credit assessment, AUS, Disclosures, Appraisal, and LOS export.`;

    return (
        <AboutSection id="about">
            <Container>
                <Grid container spacing={6} alignItems="center">
                    <Grid item xs={12} md={7}>
                        <Box sx={{ pr: { md: 4 } }}>
                            <Typography
                                variant="h3"
                                gutterBottom
                                sx={{
                                    fontWeight: 700,
                                    marginBottom: 3,
                                    color: theme.palette.primary.main,
                                }}
                            >
                                My Journey
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    fontSize: '1.1rem',
                                    lineHeight: 1.8,
                                    marginBottom: 3,
                                    color: theme.palette.text.secondary,
                                }}
                            >
                                {description}
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    fontSize: '1.1rem',
                                    lineHeight: 1.8,
                                    marginBottom: 3,
                                    color: theme.palette.text.secondary,
                                }}
                            >
                                {expertise}
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    fontSize: '1.1rem',
                                    lineHeight: 1.8,
                                    marginBottom: 3,
                                    color: theme.palette.text.secondary,
                                    fontStyle: 'italic',
                                }}
                            >
                                "I bring a strong history of successfully undertaking in-depth technical integrations with critical mortgage systems, demonstrating my commitment to delivering robust and efficient solutions in the ever-evolving landscape of mortgage technology."
                            </Typography>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                onClick={() => {
                                    document.getElementById('skills').scrollIntoView({ 
                                        behavior: 'smooth',
                                        block: 'start'
                                    });
                                }}
                                sx={{
                                    mt: 4,
                                    backgroundColor: theme.palette.primary.main,
                                    '&:hover': {
                                        backgroundColor: theme.palette.primary.dark,
                                    }
                                }}
                            >
                                Skills Showcase
                            </Button>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <ProfileImage
                                src={meInfo.aboutMeImage}
                                alt="Naga Venkata Satish"
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </AboutSection>
    );
};

export default AboutMe; 